import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FacebookService, InitParams, UIParams, UIResponse } from 'ngx-facebook';
import { DESCIPTION_BASE } from 'src/app/constant/app-constant';
import { CanonicalService } from 'src/app/service/canonical/canonical.service';
import { HomeService } from 'src/app/service/home/home.service';
import { MetaTagsService } from 'src/app/service/meta-tag/meta-tags.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FRONT_URL } from 'src/app/constant/app-constant';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

declare var adsbygoogle: any[];
@Component({
  selector: 'snack-bar',
  templateUrl: './snack-bar.html',
  styles: [
    `
    .example-pizza-party {
      color: hotpink;

    }
  `,
  ],
})
export class PizzaPartyComponent { }
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  yt = false
  value = ""
  newsPostTitle: any;
  totalImg = new Array();
  minArrImg = new Array();
  postImage = new Array();
  twitterPost = new Array();
  youtubePost: any
  durationInSeconds = 3;
  url: any
  constructor(private homeService: HomeService, private router: Router, private http: HttpClient,
    private title: Title,
    private meta: Meta, private metaService: MetaTagsService, private canonicalService: CanonicalService,
    private fb: FacebookService, private _snackBar: MatSnackBar, private sanitizer: DomSanitizer, private renderer2: Renderer2, @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document) {

    let post_name = this.router.url.split('/')[4]
    post_name = post_name.split("?")[0]
    var mySubString = this.router.url.substring(
      this.router.url.indexOf("/") + 1,
      this.router.url.lastIndexOf("/")
    );
    const date = mySubString.split('/').join('-')


    this.getPostByPostName(post_name, date)
    this.getFeaturedNews()
    // this.url = "https://f9ae-112-134-155-124.ngrok.io/" + this.router.url
    //
    let initParams: InitParams = {
      appId: '1779003665736132',
      xfbml: true,
      version: 'v2.10'
    };

    fb.init(initParams);


  }
  // url: string | undefined
  newsPost: any;
  post: any
  test: any
  otherNews = new Array();
  featuredsNews = new Array();
  notfound = false;
  postContent: any
  browser: any
  ngOnInit() {
    this.browser = isPlatformBrowser(this.platformId);
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://connect.facebook.net/en_US/sdk.js';
    this.renderer2.appendChild(this.document.body, s);

    this.canonicalService.destroyLinkForCanonicalURL()

    this.canonicalService.setCanonicalURL();

    const x = FRONT_URL + this.router.url

    this.value = x
    this.test = this.sanitizer.bypassSecurityTrustHtml('<blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="https://www.instagram.com/reel/CrGoHNJvoyH/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/reel/CrGoHNJvoyH/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/reel/CrGoHNJvoyH/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by News 1st Sri Lanka (@newsfirst.lk)</a></p></div></blockquote> <script async src="//www.instagram.com/embed.js"></script> <blockquote class="twitter-tweet"><p lang="en" dir="ltr">Do subscribe to News 1st on YouTube: <a href="https://twitter.com/NewsFirst?ref_src=twsrc%5Etfw">@NewsFirst</a>.english or <a href="https://t.co/gqeJ4OYtvP">https://t.co/gqeJ4OYtvP</a> . <a href="https://twitter.com/hashtag/Youtube?src=hash&amp;ref_src=twsrc%5Etfw">#Youtube</a> <a href="https://twitter.com/hashtag/News?src=hash&amp;ref_src=twsrc%5Etfw">#News</a> <a href="https://twitter.com/hashtag/SLNews?src=hash&amp;ref_src=twsrc%5Etfw">#SLNews</a> <a href="https://twitter.com/hashtag/NewsSL?src=hash&amp;ref_src=twsrc%5Etfw">#NewsSL</a> <a href="https://twitter.com/hashtag/Politics?src=hash&amp;ref_src=twsrc%5Etfw">#Politics</a> <a href="https://twitter.com/hashtag/Economics?src=hash&amp;ref_src=twsrc%5Etfw">#Economics</a> <a href="https://twitter.com/hashtag/SriLanka?src=hash&amp;ref_src=twsrc%5Etfw">#SriLanka</a> <a href="https://twitter.com/hashtag/Stories?src=hash&amp;ref_src=twsrc%5Etfw">#Stories</a> <a href="https://twitter.com/hashtag/BreakingNews?src=hash&amp;ref_src=twsrc%5Etfw">#BreakingNews</a> <a href="https://twitter.com/hashtag/BeInformed?src=hash&amp;ref_src=twsrc%5Etfw">#BeInformed</a> <a href="https://twitter.com/hashtag/StayTuned?src=hash&amp;ref_src=twsrc%5Etfw">#StayTuned</a> <a href="https://twitter.com/hashtag/LK?src=hash&amp;ref_src=twsrc%5Etfw">#LK</a> <a href="https://twitter.com/hashtag/SL?src=hash&amp;ref_src=twsrc%5Etfw">#SL</a> <a href="https://twitter.com/hashtag/LKA?src=hash&amp;ref_src=twsrc%5Etfw">#LKA</a> <a href="https://twitter.com/hashtag/News1st?src=hash&amp;ref_src=twsrc%5Etfw">#News1st</a> <a href="https://twitter.com/hashtag/Lanka?src=hash&amp;ref_src=twsrc%5Etfw">#Lanka</a> <a href="https://twitter.com/hashtag/Colombo?src=hash&amp;ref_src=twsrc%5Etfw">#Colombo</a> <a href="https://twitter.com/hashtag/Breaking?src=hash&amp;ref_src=twsrc%5Etfw">#Breaking</a> <a href="https://t.co/iS7aMCEVxJ">pic.twitter.com/iS7aMCEVxJ</a></p>&mdash; Newsfirst.lk Sri Lanka (@NewsfirstSL) <a href="https://twitter.com/NewsfirstSL/status/1647810907139973122?ref_src=twsrc%5Etfw">April 17, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> ');
    // if (this.browser) {
    for (let index = 0; index < 10; index++) {
      try {
        (adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
         // console.error("error");
      }

    }

    // }

  }
  // ngAfterViewInit() {
  //   if (this.browser) {
  //     for (let index = 0; index < 10; index++) {
  //       try {
  //         (adsbygoogle = window.adsbygoogle || []).push({});
  //       } catch (e) {
  //          // console.error("error");
  //       }

  //     }

  //   }
  // }

  copyUrl() {
    this._snackBar.openFromComponent(PizzaPartyComponent, {
      duration: this.durationInSeconds * 1000,
    });
  }
  author: string = ""
  post_date: string = ""
  getPostByPostName(post_name: string, date: string) {
    this.homeService.getPostByPostName(post_name, date).subscribe((resp: any) => {
      this.author = "by " + resp.author

      this.post_date = resp.date.split("T")[0] + ' | ' + resp.date.split("T")[1].split(".")[0] + ''
      // this.getPostById(resp.id)
      const desc = resp.excerpt.rendered.replace(/(<([^>]+)>)/ig, '').substring(0, 150) + ' - ' + DESCIPTION_BASE
      this.title.setTitle(resp.title.rendered)
      this.metaService.setMetaTags(resp.tags)
      this.metaService.setOgTags(resp.title.rendered, desc, resp.images.large_tile_image, '/' + resp.post_url);
      this.meta.updateTag(
        { name: 'keywords', content: resp.tags }
      )
      this.meta.updateTag(
        { name: 'description', content: desc }
      );
      this.newsPost = resp
      this.newsPostTitle = resp

      this.postContent = this.sanitizer.bypassSecurityTrustHtml(this.newsPost.content.rendered)

      this.getRelatedNews(resp.category_ID, resp.id)
      this.postImage = this.newsPost?.post_image
      this.twitterPost = this.newsPost?.twitter_post
      // console.log("=====================", this.newsPost);
      if (this.newsPost?.video_post != null) {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.newsPost?.video_post.video_id + '?autoplay=1')

      }


      if (this.newsPost?.youtube_post != undefined) {
        this.yt = true
        for (const iterator of this.newsPost?.youtube_post) {
          this.youtubePost = this.sanitizer.bypassSecurityTrustResourceUrl(iterator)
        }
      } else {
        this.yt = false
      }
      let x = 0
      if (this.newsPost.gallery_image != null) {

        for (let j = 0; j < this.newsPost.gallery_image.length / this.newsPost.gallery_count; j++) {
          this.minArrImg = []
          for (let i = 0; i < this.newsPost.gallery_count; i++) {

            this.minArrImg.push(this.newsPost.gallery_image[x + i]?.meta_value)
            if (i == 1) {
              x = x + 2
            }
          }
          this.totalImg.push(this.minArrImg)

        }
      }
    }, ((error) => {
      this.getRelatedNews(2, 0)
      console.log("==================  :   ", error.status);
      if (error.status == 500) {
        this.notfound = true;
        document.getElementById('testId')!.className = 'new_details_new';
        const img = document.getElementById("post_img") as HTMLImageElement;
        img.src = "https://storage.googleapis.com/cdn-newsfirst-lk-v2/statics/pagenot-found-banner (3).webp"
        document.getElementsByClassName("new_details_new")[0].innerHTML = "The page you have requested was not found. We will redirect you to the homepage in 5 seconds."
        var timeleft = 5;
        var downloadTimer = setInterval(function () {
          if (timeleft <= 0) {
            clearInterval(downloadTimer);
            document.getElementById("countdown")!.innerHTML = "Redirecting now....";
            document.location.href = FRONT_URL;
          } else {
            document.getElementById("countdown")!.innerHTML = "Redirecting : " + timeleft + " seconds.";
          }
          timeleft -= 1;
        }, 1000);
      }
    }))
  }


  shareFB(url: string) {



    let params: UIParams = {
      method: 'share',
      display: 'popup',
      // mobile_iframe: true,
      // href: "http://34.100.175.63:4000/" + url,
      href: "https://english.newsfirst.lk/" + url,



      // method: 'share_open_graph',
      // action_type: 'og.shares',
      // display: 'popup',

      // action_properties: JSON.stringify({
      //   object: {
      //     // 'og:url':"http://34.100.175.63:4000/2022/24/4/from-university-to-galle-face-iusf-stages-large-protest-against-president-government",
      //     'og.title': "Test Title",
      //     'og.type': "article",
      //     'og.description': "Test Desc",
      //     'og.image': 'https://cdn.newsfirst.lk/english-uploads/2022/05/a1027c67-665754_650x250_crop.jpg'
      //   }
      // })
    };


    this.fb.ui(params)
      .then((res: any) => console.log(res))
      .catch((e: any) => console.error(e));
  }



  replaceString(str: string) {

    return str.replace(/(<([^>]+)>)/ig, '');
  }

  setTitle() {
    // const title: any = localStorage.getItem("title")
    // this.title.setTitle(title)
  }

  getPostById(id: any) {

    this.setTitle()
    const url: string = 'https://newsfirst.lk/wp-json/wp/v2/posts/' + id + ''
    this.http.get(url).subscribe((res: any) => {

      this.newsPost = res


    });
    // this.homeService.getPostById(id).subscribe((resp: any) => {
    //   // this.newsPost=resp




    //   this.newsPostTitle = resp
    //   this.getRelatedNews(resp.category_ID, resp.id)
    //   this.title.setTitle(resp.title.rendered)

    //   var img = resp.content.rendered.match(/<img([\w\W]+?)>/g);




    //   this.meta.updateTag(
    //     { name: 'description', content: resp.excerpt.rendered.replace(/(<([^>]+)>)/ig, '').substring(0, 150) + ' - ' + DESCIPTION_BASE }
    //   );

    //   this.metaService.setMetaTags(resp.tags)
    // })

  }

  getRelatedNews(cat: number, id: number) {

    this.otherNews = []
    this.homeService.getPostByCategory(cat, 7, [0]).subscribe((resp: any) => {
      for (const i of resp.postResponseDto) {
        if (i.id !== id) {
          this.otherNews.push(i)
        }
      }
      // this.otherNews = resp.postResponseDto


    })
  }


  getLatestNews() {
    this.featuredsNews = []
    this.homeService.getAllNews().subscribe((resp: any) => {

      this.otherNews = resp.postResponseDto


    })
  }
  getFeaturedNews() {
    this.homeService.getPostByCategory(54387, 5, [0]).subscribe((resp: any) => {

      this.featuredsNews = resp.postResponseDto
    })
  }

  readMoreNews(id: number, title: string) {

    this.moveUp()
    // this.getPostById(id)
    // localStorage.setItem("title", title)
    this.router.navigate([`/news/${id}`]);
  }
  moveUp() {
    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  }

  postId(id: any) {
    // localStorage.setItem('id', id)
  }
}
